import { Link } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";

export default function PublicFooter() {
	const config = useAppSelector((state) => state.site.config);

	return (
		<footer className="bg-primary-700 mt-auto py-2">
			<div className="mx-auto max-w-screen-2xl px-4 sm:px-6 lg:px-8 flex flex-wrap justify-between items-center">
				<div className="text-xs text-gray-100 py-2">
					<Link
						to={config ? config.contactUsUrl : ""}
						target="_blank"
						rel="noopener noreferrer"
						id="footer-contact-us"
						className="pr-1 no-underline text-gray-100">
						Contact Us
					</Link>
					<span className="pr-1"> &bull; </span>
					<Link
						to={config ? config.aboutUsUrl : ""}
						target="_blank"
						rel="noopener noreferrer"
						id="footer-about-us"
						className="pr-1 no-underline text-gray-100">
						About Us
					</Link>
					<span className="pr-1"> &bull; </span>
					<Link
						to="/status"
						id="footer-site-status"
						className="pr-1 no-underline text-gray-100 text-right">
						Status
					</Link>
				</div>
				<div className="text-xs text-gray-100 py-2 text-right">
					<span className="block sm:inline">
						&copy;{`${new Date().getFullYear()}`} Measurement Incorporated.
					</span>{" "}
					<span className="block sm:inline text-right">All rights reserved.</span>
				</div>
			</div>
		</footer>
	);
}
